import type { IconSvgObject } from './types';

const VenetianMaskIcon: IconSvgObject = [
  ["path", { d: "M18 11C17 11 15.5 11.5 15 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 11C7 11 8.5 11.5 9 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 5V11C2 14.3137 4.68629 17 8 17C9.28058 17 10.5087 17.5087 11.4142 18.4142L12 19L12.5858 18.4142C13.4913 17.5087 14.7194 17 16 17C19.3137 17 22 14.3137 22 11V5C21.3871 6.22573 20.1343 7 18.7639 7H15.2361C13.8657 7 12.6129 7.77427 12 9C11.3871 7.77427 10.1343 7 8.76393 7H5.23607C3.86566 7 2.61287 6.22573 2 5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default VenetianMaskIcon;
